export default "__VITE_ASSET__BJDvb_Kx__"